import * as React from 'react';
import antd from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import styled from 'styled-components';
import { ColSize } from "antd/lib/col";

const { Form } = antd;

export const StyleUpdateUserProfileForm = styled(Form)`
  max-width: 300px;
  min-width: 300px;

  .login-form-forgot {
    float: right;
  }
  .login-form-button {
    width: 100%;
  }
`;



declare type ColSpanType = ColSize;

export const ReadOnlyColLayout: { [key: string]: ColSpanType } = {
  xs: { span: 11, },
  sm: { span: 11, },
  md: { span: 10, },
  lg: { span: 10, },
  xl: { span: 10, },
};


export const InputColLayout: { [key: string]: ColSpanType } = {
  xs: { span: 22, },
  sm: { span: 22, },
  md: { span: 20, },
  lg: { span: 20, },
  xl: { span: 20, },
};

export const OneSpanColLayout: { [key: string]: ColSpanType } = {
  xs: { span: 22, },
  sm: { span: 22, },
  md: { span: 21, },
  lg: { span: 21, },
  xl: { span: 21, },
};

export const ButtonColLayout: { [key: string]: ColSpanType } = {
  xs: { span: 2, offset: 4 },
  sm: { span: 2, offset: 4 },
  md: { span: 2, offset: 7 },
  lg: { span: 2, offset: 7 },
  xl: { span: 2, offset: 7 },
};
